import { createContext, useContext } from "react";
import { type SeedAudienceV3 } from "features/mediaDataRoom/models";

export interface RemarketingAdvertiserAudienceGeneratorContextValue {
  audienceName: string;
  setAudienceName: (audienceName: string) => void;
  generationStep: "pending" | "completed" | null;
  seedAudiences: SeedAudienceV3[];
  generateAudience: () => void;
  setSelectedSeedAudience: (audience: SeedAudienceV3) => void;
  selectedSeedAudience: SeedAudienceV3 | null;
}

export const RemarketingAdvertiserAudienceGeneratorContext =
  createContext<RemarketingAdvertiserAudienceGeneratorContextValue>({
    audienceName: "",
    generateAudience: () => {},
    generationStep: null,
    seedAudiences: [],
    selectedSeedAudience: null,
    setAudienceName: () => {},
    setSelectedSeedAudience: () => {},
  });

export const RemarketingAdvertiserAudienceGeneratorProvider =
  RemarketingAdvertiserAudienceGeneratorContext.Provider;

export const useRemarketingAdvertiserAudienceGenerator = () =>
  useContext(RemarketingAdvertiserAudienceGeneratorContext);
